import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { useJobPostingContext } from '@/contexts/job-posting-context';

import { getTotalChannelBudget } from './utils/channel-utils';

/** Subscribe only consumers that need channel selection or spend. */
export function useJobPostingChannels() {
  const { hookForm } = useJobPostingContext();
  const channels = useWatch({ control: hookForm.control, name: 'channels' });

  return useMemo(
    () => ({
      // Vonq products have separate keys but can share a real channel slug.
      selectedChannelKeys: Object.keys(channels ?? {}),
      selectedChannelSlugs: [
        ...new Set(Object.values(channels ?? {}).map(channel => channel.slug)),
      ],
      totalBudget: Object.values(channels ?? {}).reduce(
        (sum, channel) => sum + getTotalChannelBudget(channel),
        0,
      ),
    }),
    [channels],
  );
}
